export default __webpack_public_path__ + "static/logo-ue-fonds-region-495588a3abb819d6f34fee863dcdf791.svg";